import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IUser } from '../interfaces/user';
import { Observable, of, throwError, Subject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private storageKey: string = "CurrentUser";
  private _url: string = "/api/users/current";
  public CurrentUser = new Subject<IUser>();

  public constructor(private readonly httpClient: HttpClient, @Inject(SESSION_STORAGE) private readonly storage: WebStorageService) { }

  public getCurrentUser(): IUser {
    return this.storage.get(this.storageKey);
  }

  public login(): Observable<boolean> {
    return this.httpClient.get<IUser>(this._url)
      .pipe(map(currentUser => {
        this.storage.set(this.storageKey, currentUser);
        this.CurrentUser.next(currentUser);
        return true;
      }),
        catchError(error => {
          throwError(error);
          return of(false);
        }));
  }

  public logout(): void {
    this.storage.remove(this.storageKey);
    this.CurrentUser.next(null);
  }
}
